import React, { Component } from 'react';
import './App.css';
import { ThemeProvider } from 'styled-components';
import Header from './components/Header';
import Studio from './components/Studio';
import Photos from './components/Photos';
import Amenities from './components/Amenities';
import Pricing from './components/Pricing';
import Equipment from './components/Equipment';
import Footer from './components/Footer';
import {Element} from 'react-scroll';

const theme = {
  // Type
  bodyText: 'Grotesque MT Std',

  // Colors
  body: '#212121',
  bg: '#F4C7C7',
  light: '#FFFBFB'
}

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <main>
          <Header />
          <Element name="studio" className="studio"><Studio /></Element>
          <Element name="photos" className="photos"><Photos left /></Element>
          <Element name="amenities" className="amenities"><Amenities /></Element>
          <Element name="pricing" className="pricing"><Pricing left /></Element>
          <Element name="equipment" className="equipment"><Equipment name='equipment'/></Element>
          <Element name="contact" className="contact"><Footer /></Element>
        </main>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js